/**
 *
 * @module HTML5 media events enum
 * @desc Media event enumeration
 *
 */
export default {
    DURATION_CHANGE: 'durationchange',
    MEDIA_COMPLETE: 'ended',
    MEDIA_LOAD_START: 'loadstart',
    CANPLAY: 'canplay',
    MEDIA_LOADED_DATA: 'loadeddata',
    MEDIA_LOADED_META: 'loadedmetadata',
    MEDIA_START: 'play',
    MEDIA_PAUSE: 'pause',
    MEDIA_PLAYING: 'playing',
    MEDIA_SEEKING: 'seeking',
    MEDIA_SEEKED: 'seeked',
    MEDIA_STALLED: 'stalled',
    TIME_UPDATE: 'timeupdate',
    VOLUME_CHANGE: 'volumechange',
    TEXT_TRACKS_AVAILABLE: 'texttracksavailable',
    TEXT_TRACK_ENABLED: 'texttrackenabled',
    TEXT_TRACK_DISABLED: 'texttrackdisabled',
    // TODO: html5 media events
    ABORT: 'abort',
    CANPLAYTHROUGH: 'canplaythrough',
    EMPTIED: 'emptied',
    HTML5_ERROR: 'error', // This collided with HLS.ERROR === 'hlsError' that's why `HTML5_ERROR`
    INTERRUPTBEGIN: 'interruptbegin',
    INTERRUPTEND: 'interruptend',
    PROGRESS: 'progress',
    RATECHANGE: 'ratechange',
    SUSPEND: 'suspend',
    WAITING: 'waiting',
};
